module.exports = __webpack_public_path__ + "img/hr-heated-straight-vertical-3.49984b7a.png";